import React, { forwardRef, Fragment } from 'react';
import styled from 'styled-components';
import { IMeasureFilterValue } from '../../../../../../redux/slices/oldBuilder';
import MeasureFilterDisplayValue from './MeasureFilterDisplayValue';
import { theme } from '../../../../../../styles/theme';

interface IProps {
  measureFilterValues: IMeasureFilterValue[];
}

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 8px;
  row-gap: 6px;
`;

const Operator = styled.div`
  text-transform: uppercase;
  font-weight: 500;
  line-height: 1.5;
  color: ${theme.colors.secondary800};
`;

const MeasureFilterDisplayValues = forwardRef<HTMLDivElement, IProps>(
  ({ measureFilterValues }, ref) => (
    <Container ref={ref}>
      {measureFilterValues.map((measureFilterValue, index) => (
        <Fragment key={`measure-filter-value-${measureFilterValue.measureKey}`}>
          {index > 0 && <Operator>And</Operator>}
          <MeasureFilterDisplayValue measureFilterValue={measureFilterValue} />
        </Fragment>
      ))}
    </Container>
  ),
);

export default MeasureFilterDisplayValues;
